import { Component, OnInit } from '@angular/core';

import { IMyDpOptions } from 'mydatepicker';
import { formatDate } from '../common/Utilities/date-utilities';

import { CommonService } from '../common/services/common.service';
import { UserAccountService } from './user-account.service';
import { UserObject } from '../models/userdetails';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-account',
  templateUrl: './user-account.component.html',
  styleUrls: ['./user-account.component.css']
})
export class UserAccountComponent implements OnInit {

  myDatePickerOptions: IMyDpOptions;
  selectedTab = 'PROFILE';
  isPasswordChange = false;
 // userDetails: any = {};
  bookingDetails: any = {};
  creditDetails: any = {};
  formattedDOB: any = {};
  newPassword = '';
  confirmPassword = '';
  errorMap = new Map();
  // userId = localStorage.getItem('userId');

  userObject:UserObject=null;
  constructor(private _router: Router,public _commonService: CommonService, private _userAccountService: UserAccountService) { }

  ngOnInit() {
    this._commonService.loadScript();
    // this.getUserDetails();
    this.getUserObject();
    this.getBookingDetails();
  }

  // getUserDetails() {
  //   this._userAccountService.getUserDetails(this.userId).subscribe((data: any) => {
  //     this.userDetails = data.status && data.message === 'success' ? data.data : {};
  //     this.bindDateToPicker(this.userDetails.dob);
  //   });
  // }

  getUserObject(){
    this._commonService.userDetails.subscribe((res:UserObject)=>{
      if(res != null){
        this.userObject = res;
        this.bindDateToPicker(res.dob);
      }  
    })
  }

  validateMobileNumber() {
    this.userObject.mobile = this.removeZerosinPhone(this.userObject.mobile);
  }

  removeZerosinPhone(value:string){
    return value.replace(/^[0|\D]*/,'0');
  }

  bindDateToPicker(dateString) {
    const DOB = new Date(dateString);
    this.formattedDOB = { date: { day: DOB.getDate(), month: DOB.getMonth() + 1, year: DOB.getFullYear()} }; // getMonth index starts from 0

  }

  getBookingDetails() {
    this._userAccountService.getBookings(this.userObject.email).subscribe((data: any) => {
      this.bookingDetails = data.status && data.message === 'success' ? data.data : {};
     console.log(this.bookingDetails);
      /* booking details comes as stringified object, hence parsed as JSON */
      for (let item of this.bookingDetails) {
        item.bookingDetails = JSON.parse(item.bookingDetails);
      }

    });
  }

  getCreditDetails() {
    this._userAccountService.getCredits(this.userObject.email).subscribe((data: any) => {
      this.creditDetails = data.status && data.message === 'success' ? data.data : {};
    });
  }

  onDobChange(event) {
    this.bindDateToPicker(this.userObject.dob);
  }

  checkPasswordMatch() {
    if ((this.newPassword && this.confirmPassword) || (!this.newPassword || !this.confirmPassword)) {
      this.newPassword !== this.confirmPassword ? this.errorMap.set('password', true) : this.errorMap.set('password', false);
    }
  }

  validateUserDetails() {
    this.checkPasswordMatch();
    if (this.userObject.name && this.userObject.surname && this.formattedDOB &&
        this.userObject.email && this.userObject.mobile && !this.errorMap.get('password')) {
      this.updateUserDetails();
    }
  }

  getUpdatedUserDetails() {
    const updatedUserDetails = {
      // 'Id': this.userObject,
      'Name': this.userObject.name,
      'Surname': this.userObject.surname,
      'DOB': formatDate(this.formattedDOB),
      'Email': this.userObject.email,
      'Password': this.isPasswordChange ? this.newPassword : '',
      'Mobile': this.userObject.mobile
    };
    return updatedUserDetails;
  }

  updateUserDetails() {
    //console.log(this.getUpdatedUserDetails())
    this._userAccountService.updateUserDetails(this.getUpdatedUserDetails()).subscribe((data: any) => {
      //console.log(data)
      this.userObject = data.status && data.message === 'success' ? data.data : {};
      this.bindDateToPicker(this.userObject.dob);
      if (this.isPasswordChange) { this.resetPasswordDetails(); }
    });
  }

  changePassword() {
    this._userAccountService.changePassword(this.getUpdatedUserDetails()).subscribe((data: any) => {
      this.userObject = data.status && data.message === 'success' ? data.data : {};
      this.bindDateToPicker(this.userObject.dob);
      this.resetPasswordDetails();
    });
  }

  resetPasswordDetails(){
    this.isPasswordChange = false;
    this.newPassword = this.confirmPassword = '';
    this.errorMap.set('password', false);
  }

}
